import {
  config
} from '../config';


const init = () => {
  // Make video embed responsive
  $('.js-responsive-video').fitVids();

  // Header video add/remove on different screen sizes
  if (document.querySelector('video#header-video')) {
    enquire.register(`screen and (min-width: ${config.breakpoint.smMax}px)`, {
      match: function () {
        setTimeout(() => {
          createVideoHeader();
        }, 100);
      }
    });
  }

};

const createVideoHeader = () => {

  // Define the video object this source is contained inside
  var sources = document.querySelectorAll('video#header-video source');
  var video = document.querySelector('video#header-video');
  for (var i = 0; i < sources.length; i++) {
    sources[i].setAttribute('src', sources[i].getAttribute('data-src'));
  }

  video.load();
  video.muted = 'muted';
};

export {
  init
};